import { render, staticRenderFns } from "./SelfServiceOpenPayslips.vue?vue&type=template&id=9f30183e"
import script from "./SelfServiceOpenPayslips.vue?vue&type=script&lang=js"
export * from "./SelfServiceOpenPayslips.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports